/* IconMultipleSelectListControlRenderer.js */

"use strict";
const MultipleSelectListControlRenderer = require("../multiple/MultipleSelectListControlRenderer");
const _ = require("lodash");

class IconMultipleSelectListControlRenderer extends MultipleSelectListControlRenderer {
    constructor(model) {
        super(model);
        this._rootElem.classList.add("icon");
        if (this._model.hasOptionIcons()) {
            this._rootElem.classList.add("icon-options");
        }
        if (this._model.hasSelectedOptionIcons()) {
            this._rootElem.classList.add("selected-icon-options");
        }
        this._onClickEvent = this._onClickEvent.bind(this);
        this.render();
    }

    /**
     * Set the inner buttons with the passed in array of buttons from the model
     * @param newVal {Array}
     * @private
     */
    _setOptions(newVal) {
        this._selections.forEach((selection) => {
            selection.removeEventListener("click", this._onClickEvent);
        });
        this._selections = [];
        this._rootElem.innerHTML = "";
        newVal.forEach((option) => {
            let selection = document.createElement("list-option");
            selection.innerHTML = option.label;
            selection.value = option.value;
            this._setOptionIcon(option.value, selection);
            if (option.disabled === true) {
                selection.setAttribute("disabled", true);
            }
            selection.addEventListener("click", this._onClickEvent);
            this._rootElem.appendChild(selection);
            this._selections.push(selection);
        });
    }

    /**
     * Sets the icon for the option
     * @param optionValue
     * @param selection
     * @private
     */
    _setOptionIcon(optionValue, selection) {
        let optionIcon = this._model.getOptionIcon(optionValue);
        let iconEl = document.createElement("base-icon-gl");
        iconEl.dataset.icon = optionIcon;
        selection.insertAdjacentElement("afterbegin", iconEl);
        selection._glIconElem = iconEl;
    }

    /**
     * Set the inner button that matches the new value active
     * @param newVals {array}
     * @private
     */
    _setValue(newVal) {
        this._selections.forEach((selection) => {
            selection.removeAttribute("data-active");
            selection._glIconElem.dataset.icon = this._model.getOptionIcon(selection.value);
        });
        newVal.forEach((val) => {
            this._selections.forEach((selection) => {
                if (_.isEqual(selection.value, val)) {
                    selection.dataset.active = true;
                    selection._glIconElem.dataset.icon = this._model.getSelectedOptionIcon(
                        selection.value
                    );
                }
            });
        });
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = IconMultipleSelectListControlRenderer;
